
import React, { Component } from 'react';
import { Form } from 'react-bootstrap';
import '../../assets/css/component/Input.css'

class UniqCodeInput extends Component {
    render() {
        const { label_name, placeholder, name, value, onChange, onBlur, error } = this.props;

        return (
            <>
                <Form.Group className="mb-2">
                    <div style={{ position: "relative" }}>
                        <Form.Label className='form_label'>{label_name}</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder={placeholder}
                            className='form_input'
                            name={name}
                            value={value}
                            onChange={onChange}
                            onBlur={onBlur}
                        />
                        <span className='uniq_code'>-EMP-001</span>
                    </div>
                    {error}
                </Form.Group>
            </>
        );
    }
}

export default UniqCodeInput;





























